import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getFollowers } from '@/services/follow.service';
import { FollowersListComponent } from './FollowersList.component';

interface FollowersListProps {
  userId: string;
  username: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const FollowersList: React.FC<FollowersListProps> = ({
  userId,
  username,
  open,
  onOpenChange,
}) => {
  const navigate = useNavigate();
  const [followers, setFollowers] = useState([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (open) {
      const fetchFollowers = async () => {
        setLoading(true);
        try {
          const followersList = await getFollowers(userId);
          setFollowers(followersList);
        } catch (error) {
          console.error('Error fetching followers:', error);
        } finally {
          setLoading(false);
        }
      };

      fetchFollowers();
    }
  }, [userId, open]);

  const handleUserClick = (userUsername: string) => {
    navigate(`/user/${userUsername}`);
  };

  return (
    <FollowersListComponent
      username={username}
      followers={followers}
      loading={loading}
      open={open}
      onOpenChange={onOpenChange}
      onUserClick={handleUserClick}
    />
  );
};

